import Image from 'next/image';
import React from 'react';
import { useTranslations } from '../../locales/useTranslations';
import { BiCheckCircle, BiCodeAlt, BiRocket, BiPalette, BiMobile, BiCog, BiGroup, BiPlug, BiRefresh, BiBell } from 'react-icons/bi';
import FadeInAnimation from '../Common/FadeInAnimation';

const AppDevelopmentReactNativeText = () => {
    const { t } = useTranslations();

    const benefits = [
        { icon: BiRocket, text: t('appDevelopment_reactNative_benefits_performance') },
        { icon: BiGroup, text: t('appDevelopment_reactNative_benefits_community') },
        { icon: BiMobile, text: t('appDevelopment_reactNative_benefits_development') },
        { icon: BiPlug, text: t('appDevelopment_reactNative_benefits_integration') },
        { icon: BiRefresh, text: t('appDevelopment_reactNative_benefits_reloading') },
        { icon: BiCog, text: t('appDevelopment_reactNative_benefits_cost') }
    ];

    const skills = [
        { icon: BiCodeAlt, text: t('appDevelopment_reactNative_skills_state') },
        { icon: BiPlug, text: t('appDevelopment_reactNative_skills_modules') },
        { icon: BiRocket, text: t('appDevelopment_reactNative_skills_apis') },
        { icon: BiCog, text: t('appDevelopment_reactNative_skills_optimization') },
        { icon: BiBell, text: t('appDevelopment_reactNative_skills_notifications') },
        { icon: BiCodeAlt, text: t('appDevelopment_reactNative_skills_testing') }
    ];

    return (
        <section className="about-area ptb-100 appdev-tech-section">
            {/* Dekorative Hintergrund-Elemente */}
            <div className="appdev-tech-section__decoration appdev-tech-section__decoration--left"></div>

            <div className="container appdev-tech-section__container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-md-12">
                        <FadeInAnimation direction="right" delay={50}>
                            <div className="about-content">
                                <span className="appdev-tech-badge">
                                    {t('appDevelopment_reactNative_subtitle')}
                                </span>

                                <h2 className="appdev-tech-title">
                                    {t('appDevelopment_reactNative_title')}
                                </h2>

                                <p className="appdev-tech-description">
                                    {t('appDevelopment_reactNative_description1')}
                                </p>

                                <div className="appdev-tech-card">
                                    <h3 className="appdev-tech-card__header">
                                        <BiCheckCircle className="appdev-tech-card__header-icon" />
                                        {t('appDevelopment_reactNative_advantages')}
                                    </h3>
                                    <div className="appdev-tech-card__grid">
                                        {benefits.map((benefit, index) => {
                                            const Icon = benefit.icon;
                                            return (
                                                <div key={index} className="appdev-tech-item">
                                                    <Icon className="appdev-tech-item__icon" />
                                                    <span className="appdev-tech-item__text">
                                                        {benefit.text}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <div className="appdev-tech-card">
                                    <h3 className="appdev-tech-card__header">
                                        <BiRocket className="appdev-tech-card__header-icon" />
                                        {t('appDevelopment_reactNative_expertise')}
                                    </h3>
                                    <div className="appdev-tech-card__grid">
                                        {skills.map((skill, index) => {
                                            const Icon = skill.icon;
                                            return (
                                                <div key={index} className="appdev-tech-item">
                                                    <Icon className="appdev-tech-item__icon" />
                                                    <span className="appdev-tech-item__text">
                                                        {skill.text}
                                                    </span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>

                                <p className="appdev-tech-description" style={{ marginTop: '1.25rem', marginBottom: 0 }}>
                                    {t('appDevelopment_reactNative_description2')}
                                </p>
                            </div>
                        </FadeInAnimation>
                    </div>

                    <div className="col-lg-6 col-md-12 mb-4">
                        <FadeInAnimation direction="left" delay={100}>
                            <div className="appdev-tech-image-card">
                                <Image
                                    src="/images/app-development/react-native.svg"
                                    alt="simplify data - React Native"
                                    width={400}
                                    height={400}
                                    className="appdev-tech-image-card__image"
                                />
                            </div>
                        </FadeInAnimation>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default AppDevelopmentReactNativeText;
